'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { useMemo } from 'react';
import { createBareContext } from '@s7/react-utils';
import { createTopics } from './createTopics.js';

/**
 * Функция создания провайдера аналитики
 *
 * @param definitions { topic1: { method1: (params?: any) => ['event_name', AbstractPayload] }
 * | [{defaultValue: 'example'},  { method1: (params?: any) => ['event_name', AbstractPayload] }] }
 * @returns [AnalyticsProvider, useAnalytics]
 */ function createAnalyticsContext(definitions) {
    const [AnalyticsContextProvider, useAnalyticsContext] = createBareContext();
    function useAnalytics(topicName) {
        var _useAnalyticsContext_topics, _useAnalyticsContext;
        return ((_useAnalyticsContext = useAnalyticsContext()) == null ? void 0 : (_useAnalyticsContext_topics = _useAnalyticsContext.topics) == null ? void 0 : _useAnalyticsContext_topics[topicName]) || {};
    }
    const AnalyticsProvider = ({ children, analytics })=>{
        const topics = useMemo(()=>createTopics(definitions, analytics), [
            analytics
        ]);
        return /*#__PURE__*/ jsx(AnalyticsContextProvider, {
            value: {
                topics
            },
            children: children
        });
    };
    return [
        AnalyticsProvider,
        useAnalytics
    ];
}

export { createAnalyticsContext };
//# sourceMappingURL=createAnalyticsContext.js.map
